import { t } from "../i18n/index.ts";

/** Something's title (an item's, a file's), or "Untitled" when it has none. */
export const titleOf = (x: { title?: string | null | undefined }): string => x.title || t("common.untitled");

/** The name to tell a file's type by: its item's title (renaming keeps a file's extension; without one, its type tells). */
export function fileNameOf(x: { title?: string | undefined }): string {
  return x.title ?? "";
}
